import {NgModule} from '@angular/core';
import {ModalModule} from '../modal';
import {ApplicationReloadService} from './application-reload.service';

@NgModule({
    imports: [
        ModalModule
    ],
    providers: [
        ApplicationReloadService
    ]
})
export class ApplicationReloadModule {}
